export default "__VITE_ASSET__DkxcyyZa__"